/* eslint-disable max-lines-per-function */
import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { Typography } from '@material-ui/core';
import MUITextField from '../../shared/components/MUITextField';
import { Button } from 'semantic-ui-react';
import { useCreateAmenityTags, useUpdateAmenityTags } from '../../api/amenity-tags';


const styles = {
    formBoxBottom: {
        margin: '0px 0px',
        padding: '20px 0px',
        display: 'flex',
        justifyContent: 'flex-end'
    },
    formButton: {
        width: '500px',
        height: '10px'
    }
};

const FormTags = props => {

    const { initialValues } = props;

    const isNew = !initialValues.id;
    const { mutate: createAmenityTags } = useCreateAmenityTags();
    const { mutate: updateAmenityTags } = useUpdateAmenityTags();

    const onSubmit = async values => {

        const payload = {
            tag: values.name
        };

        if (isNew) {
            await createAmenityTags(payload);
            props.setModalTagsOpen(false);

            return;
        }
        await updateAmenityTags({
            payload: {
                tag: values.name,
                old_tag_value: initialValues.name
            }
        });
        props.setModalTagsOpen(false);

    };

    return (
        <FinalForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine, values, form: { mutators }
            }) => (
                <form onSubmit={handleSubmit}>

                    <Grid item >
                        <Typography variant='h5' style={{ color: '#002144' }}>New Tag</Typography>
                    </Grid>

                    <p></p>


                    <Box sx={{ width: '100%' }} style={{ marginTop: '20px' }}>

                        <MUITextField
                            name='name'
                            label='Tag'
                            required
                            variant='outlined'
                            defaultValue={initialValues?.name || ''}
                        />
                    </Box>

                    <div style={styles.formBoxBottom}>
                        <Button negative onClick={() => props.setModalTagsOpen(false)}>
                            Cancel
                        </Button>
                        <Button floated='right' positive disabled={submitting || pristine}>
                            Submit
                        </Button>

                    </div>
                </form>
            )}
        />
    );
};

export default FormTags;
